import {multiguru} from './apis/multiguru'
import API from 'vuex-requests/src/store/backends/API'

export default {
  name: 'APIMixin',
  data () {
    return {
      multiguru: multiguru
    }
  },
  computed: {
    $multiguru () {
      let token = this.$store.getters.token
      let config = { // todo: extract to config
        baseUrl: process.env.MULTIGURU_API_ROOT,
        headers: {
          authorization: `Bearer ${token}`
        }
      }
      return this.getAPI('multiguru', config)
    }
  },
  methods: {
    getAPI (name, config = {}) {
      let api = new API(name, this.$store)
      api.baseUrl = process.env[`${name.toUpperCase()}_URL`]
      api.headers = { 'Content-Type': 'application/json' }
      api.resources = () => { return this[name].resources }

      Object.assign(api, config)

      return api
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/api.js